import React, { useEffect, useState } from "react";

// STYLES
import {
  NewsAndMediaSectionContainer,
  Container,
  Card,
  ImgWrapper,
  TextWrapper,
  SvgBackground,
  Img,
  ButtonWrapper,
} from "./NewsAndMediaStyled";

// LIBRARIES

import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

// ASSETS

import QuarterCircle from "assets/svg/QuarterCircle.svg";

// MISC
import { useNewsCards } from "./NewsAndMediaModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import aboutService from "services/aboutService";

// CONFIGURATION

//REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS

import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";

const NewsAndMediaSection = () => {
  // PROPERTIES

  // API REQUESTS

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const { t } = useTranslation();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS
  const newsCards = useNewsCards();
  const [documents, setDocuments] = useState<any>(null);

  // LIFE CYCLE
  useEffect(() => {
    aboutService
      .getDocuments()
      .then((response) => {
        // console.log("getDocuments response", response);
        setDocuments(response);
      })
      .catch((err) => {
        console.log("getDocuments error", err);
      });
  }, []);

  // EVENT HANDLERS
  const handleNavigateCard = (route?: string) => {
    if (route && route !== "no-routing") navigate(route);
  };

  const handleDownload = (e: React.MouseEvent, fileUrl: string) => {
    e.stopPropagation(); // Prevent triggering navigation

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "kit-media.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <NewsAndMediaSectionContainer>
      <SvgBackground>
        <Img src={QuarterCircle} alt="Background Quarter Circle" />
      </SvgBackground>
      <Container>
        {newsCards.map((card) => (
          <Card
            key={card.id}
            backgroundColor={card.backgroundColor}
            textColor={card.textColor}
            gridArea={card.gridArea}
            onClick={(event) => card.downloadUrl
              ? handleDownload(event, card.downloadUrl)
              : handleNavigateCard(card.route)}
            biggerCursor={biggerCursor}
          >
            <ImgWrapper
              position={card.svgPosition}
              transform={card.svgTransform}
              opacity={card.svgOpacity}
            >
              <Img imgProps={card.imgProps} src={card.svg} alt={card.title} />
            </ImgWrapper>
            <TextWrapper placement={card.textPlacement}>
              {card.title.split("\n").map((line, index) => (
                <CustomText key={index} text={line} type={TextType.H3} />
              ))}
            </TextWrapper>
            {card.downloadUrl && (
              <ButtonWrapper>
                <ButtonAtom
                  type={ButtonType.ArrowDownRed}
                  text={t("view.newsAndMedia.download")}
                  arrowDown={true}
                  rightIcon={true}
                  onClick={(e) => handleDownload(e, card.downloadUrl)}
                />
              </ButtonWrapper>
            )}
          </Card>
        ))}
      </Container>
    </NewsAndMediaSectionContainer>
  );
};

export default NewsAndMediaSection;
